

/**
 *
 * @param id
 * @returns {ClientRect}
 */
export const getSize = (id = "root") => {
  return document.getElementById(id).getBoundingClientRect();
}

export const isIE = /MSIE \d|Trident.*rv:/.test(navigator.userAgent);

export function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};

export const getOrientation = () => {
  switch (window.orientation) {
    case -90:
      return 'landscape';
    case 90:
      return 'landscape';
    case 0:
      return 'portrait';
    default:
      return 'portrait';
  }
}

export const isIFrame = () => {
  return window.location.href.indexOf('web-viewer') > -1 || window.location.port === '3000';
}




// WEBPACK FOOTER //
// ./src/tools/utils.js